<p style="margin-bottom: 0px">
  <span class="animated-text">
    <span *ngFor="let letter of letters" class="letter" [ngStyle]="{ color: letter.color }">
      {{ letter.char }}
    </span>
  </span>
</p>

<div class="mt-1 promotions-list">
  <div *ngFor="let ticket of currentPromos" class="promotion-ticket">
    <!-- Tickets separados para usuarios NO FIDELIZADOS con promoción exclusiva -->
    <ng-container *ngIf="hasExclusivePromotion(ticket) && !enrollInformation">
      <!-- Ticket superior: Promoción exclusiva Happylanders -->
      <div class="promotion-item" (click)="onExclusivePromotionClick(ticket, $event)">
        <div class="ticket-left" [style.background]="ticket.exclusivePromotion.color ?? '#B06AB3'" [style.border-bottom-left-radius]="'0px'">
          <div class="ticket-section">
            <span class="ticket-label full-text" style="color: yellow">{{ getAudienceLabel(ticket.exclusivePromotion) }}</span>
            <span class="ticket-label short-text" style="color: yellow">{{ getAudienceLabelShort(ticket.exclusivePromotion) }}</span>
            <span class="ticket-value-medium">${{ ticket.exclusivePromotion.paymentAmount | number }}</span>
          </div>

          <div class="ticket-separator">
            <span class="operator">+</span>
          </div>

          <div class="ticket-section">
            <span class="ticket-label">EXTRA {{ getPrimaryBenefitLabel(ticket.exclusivePromotion) }}</span>
            <span class="ticket-value-medium">{{ getPrimaryBenefitValue(ticket.exclusivePromotion) | number : '1.0-0' }}</span>
          </div>
        </div>

        <div class="ticket-equal-sign">
          <span class="operator">=</span>
        </div>

        <div
          class="ticket-right"
          [style.background]="ticket.exclusivePromotion.color ?? '#B06AB3'"
          [style.border-bottom-left-radius]="'0px'"
          [style.border-bottom-right-radius]="'0px'"
        >
          <div class="ticket-result" *ngIf="ticket.exclusivePromotion.typeOfPromotion === 'ONLY_CASH'">
            <span class="ticket-label">JUEGAS</span>
            <span class="ticket-value-medium">{{ getTotalPlayable(ticket.exclusivePromotion) / 1000 | number : '1.0-0' }}K</span>
          </div>

          <div class="ticket-result-horizontal" *ngIf="ticket.exclusivePromotion.typeOfPromotion === 'CASH_AND_TICKETS'">
            <div class="result-group">
              <span class="ticket-label">JUEGAS</span>
              <span class="ticket-value-medium">{{ getTotalPlayable(ticket.exclusivePromotion) / 1000 | number : '1.0-0' }}K</span>
            </div>
            <span class="result-plus">+</span>
            <div class="result-group mr-1">
              <span class="ticket-label">ETICKETS</span>
              <span class="ticket-value-medium">{{ ticket.exclusivePromotion.tickets | number }}</span>
            </div>
          </div>

          <div class="ticket-result-horizontal" *ngIf="ticket.exclusivePromotion.typeOfPromotion === 'CASH_AND_GAMES'">
            <div class="result-group">
              <span class="ticket-label">JUEGAS</span>
              <span class="ticket-value-medium">{{ getTotalPlayable(ticket.exclusivePromotion) / 1000 | number : '1.0-0' }}K</span>
            </div>
            <span class="result-plus">+</span>
            <div class="result-group mr-1">
              <span class="ticket-label">JUGADAS</span>
              <span class="ticket-value-medium">{{ ticket.exclusivePromotion.token + ticket.exclusivePromotion.bonusToken | number }}</span>
            </div>
          </div>

          <img src="assets/images/icons/ic_happylander_light.svg" alt="Happylanders" class="happylanders-icon" />
          <div class="ticket-notch ticket-notch-top"></div>
        </div>
      </div>

      <!-- Ticket inferior: Promoción general -->
      <div class="promotion-item" (click)="goToPayment(ticket.accessiblePromotion); $event.stopPropagation()">
        <div
          class="ticket-left"
          [style.background]="helperService.lightenColor(ticket.exclusivePromotion.color, 15) ?? helperService.lightenColor('#B06AB3', 15)"
          [style.border-top-left-radius]="'0px'"
        >
          <div class="ticket-section">
            <span class="ticket-label full-text" style="color: yellow">{{ getAudienceLabel(ticket.accessiblePromotion) }}</span>
            <span class="ticket-label short-text" style="color: yellow">{{ getAudienceLabelShort(ticket.accessiblePromotion) }}</span>
            <span class="ticket-value-medium">${{ ticket.accessiblePromotion.paymentAmount | number }}</span>
          </div>

          <div class="ticket-separator">
            <span class="operator">+</span>
          </div>

          <div class="ticket-section">
            <span class="ticket-label">{{ getPrimaryBenefitLabel(ticket.accessiblePromotion) }}</span>
            <span class="ticket-value-medium">{{ getPrimaryBenefitValue(ticket.accessiblePromotion) | number : '1.0-0' }}</span>
          </div>
        </div>

        <div class="ticket-equal-sign">
          <span class="operator">=</span>
        </div>

        <div
          class="ticket-right"
          [style.background]="helperService.lightenColor(ticket.exclusivePromotion.color, 15) ?? helperService.lightenColor('#B06AB3', 15)"
          [style.border-top-left-radius]="'0px'"
          [style.border-top-right-radius]="'0px'"
        >
          <div class="ticket-result" *ngIf="ticket.accessiblePromotion.typeOfPromotion === 'ONLY_CASH'">
            <span class="ticket-label">JUEGAS</span>
            <span class="ticket-value-medium">{{ getTotalPlayable(ticket.accessiblePromotion) / 1000 | number : '1.0-0' }}K</span>
          </div>

          <div class="ticket-result-horizontal" *ngIf="ticket.accessiblePromotion.typeOfPromotion === 'CASH_AND_TICKETS'">
            <div class="result-group">
              <span class="ticket-label">JUEGAS</span>
              <span class="ticket-value-medium">{{ getTotalPlayable(ticket.accessiblePromotion) / 1000 | number : '1.0-0' }}K</span>
            </div>
            <span class="result-plus">+</span>
            <div class="result-group mr-1">
              <span class="ticket-label">ETICKETS</span>
              <span class="ticket-value-medium">{{ ticket.accessiblePromotion.tickets | number }}</span>
            </div>
          </div>

          <div class="ticket-result-horizontal" *ngIf="ticket.accessiblePromotion.typeOfPromotion === 'CASH_AND_GAMES'">
            <div class="result-group">
              <span class="ticket-label">JUEGAS</span>
              <span class="ticket-value-medium">{{ getTotalPlayable(ticket.accessiblePromotion) / 1000 | number : '1.0-0' }}K</span>
            </div>
            <span class="result-plus">+</span>
            <div class="result-group mr-1">
              <span class="ticket-label">JUGADAS</span>
              <span class="ticket-value-medium">{{ ticket.accessiblePromotion.token + ticket.accessiblePromotion.bonusToken | number }}</span>
            </div>
          </div>

          <div class="ticket-notch ticket-notch-bottom"></div>
        </div>
      </div>
    </ng-container>

    <!-- Ticket simple para usuarios FIDELIZADOS o sin promoción exclusiva -->
    <ng-container *ngIf="!hasExclusivePromotion(ticket) || enrollInformation">
      <ng-container *ngIf="ticket.accessiblePromotion as promotion">
        <div class="promotion-item" (click)="goToPayment(promotion)">
          <div class="ticket-left" [style.background]="promotion.color ?? '#B06AB3'">
            <div class="ticket-section">
              <span class="ticket-label full-text" style="color: yellow">{{ getAudienceLabel(promotion) }}</span>
              <span class="ticket-label short-text" style="color: yellow">{{ getAudienceLabelShort(promotion) }}</span>
              <span class="ticket-value-medium">${{ promotion.paymentAmount | number }}</span>
            </div>

            <div class="ticket-separator">
              <span class="operator">+</span>
            </div>

            <div class="ticket-section">
              <span class="ticket-label">EXTRA {{ getPrimaryBenefitLabel(promotion) }}</span>
              <span class="ticket-value-medium">{{ getPrimaryBenefitValue(promotion) | number }}</span>
            </div>
          </div>

          <div class="ticket-equal-sign">
            <span class="operator">=</span>
          </div>

          <div class="ticket-right" [style.background]="promotion.color ?? '#B06AB3'">
            <div class="ticket-result" *ngIf="promotion.typeOfPromotion === 'ONLY_CASH'">
              <span class="ticket-label">JUEGAS</span>
              <span class="ticket-value-medium">{{ getTotalPlayable(promotion) / 1000 | number : '1.0-0' }}K</span>
            </div>

            <div class="ticket-result-horizontal" *ngIf="promotion.typeOfPromotion === 'CASH_AND_TICKETS'">
              <div class="result-group">
                <span class="ticket-label">JUEGAS</span>
                <span class="ticket-value-medium">{{ getTotalPlayable(promotion) / 1000 | number : '1.0-0' }}K</span>
              </div>
              <span class="result-plus">+</span>
              <div class="result-group mr-1">
                <span class="ticket-label">ETICKETS</span>
                <span class="ticket-value-medium">{{ promotion.tickets | number }}</span>
              </div>
            </div>

            <div class="ticket-result-horizontal" *ngIf="promotion.typeOfPromotion === 'CASH_AND_GAMES'">
              <div class="result-group">
                <span class="ticket-label">JUEGAS</span>
                <span class="ticket-value-medium">{{ getTotalPlayable(promotion) / 1000 | number : '1.0-0' }}K</span>
              </div>
              <span class="result-plus">+</span>
              <div class="result-group mr-1">
                <span class="ticket-label">JUGADAS</span>
                <span class="ticket-value-medium">{{ promotion.token + promotion.bonusToken | number }}</span>
              </div>
            </div>

            <img *ngIf="enrollInformation" src="assets/images/icons/ic_happylander_light.svg" alt="Happylanders" class="happylanders-icon" />

            <div class="ticket-notch ticket-notch-top"></div>
            <div class="ticket-notch ticket-notch-bottom"></div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
